<template>
  <div class="vs-select-group">
    <h4 v-if="!select.filterValue">{{ title }}</h4>
    <slot />
  </div>
</template>

<script>
export default {
  name: "VsSelectGroup",
  inject: ["vsSelect"],
  props: {
    title: {
      type: String,
      default: "Group",
    },
  },
  computed: {
    select() {
      return this.vsSelect;
    },
  },
};
</script>
